module.exports = __webpack_public_path__ + "img/aboutUsImg06.67b97ba6.png";